import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend/index';
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import './AdvisorMiniPanel_Home.scss';
import { PanelKey_Home } from '../../../_shared.js';
import { Advisor_ErrorBoundary } from '../../components/Advisor_ErrorBoundary/Advisor_ErrorBoundary.js';
import { Component_HomeScores } from '../../components/home-panel/home-scores/Component_HomeScores.js';
import { FadeScrollWrapper } from '@app/styles';
import { Component_MetapathwayOrderCart } from '../../components/next-steps/metapathway-order-cart/Component_MetapathwayOrderCart.js';
import { ModuleFE_Spotlight } from '../../../modules/ModuleFE_Spotlight/index.js';
import { Component_HomeHPIV2 } from '../../components/home-panel/v2/home-hpi/Component_HomeHPIV2.js';
import { Component_HomeHistory } from '../../components/home-panel/v2/home-history/Component_HomeHistory.js';
import { Component_HomeDDXV2 } from '../../components/home-panel/v2/home-ddx/Component_HomeDDXV2.js';
import { Component_CatchUp_Vitals } from '../../components/catch-up/vitals/Component_CatchUp_Vitals.js';
import { Component_HomeHeader } from '../../components/home-panel/Component_HomeHeader/Component_HomeHeader.js';
import { Component_PertinentData } from '../../components/pertinent-data/Component_PertinentData/Component_PertinentData.js';
import { ModuleFE_AdvisorABTesting } from '../../../modules/ModuleFE_AdvisorSettings/ModuleFE_AdvisorABTesting.js';
import { exists } from '@nu-art/ts-common';
import { ABTestValue } from '@app/org-shared';
export class AdvisorMiniPanel_Home extends AdvisorMiniPanel {
    static defaultProps = {
        panelKey: PanelKey_Home,
        panelType: 'primary',
    };
    //######################### Life Cycle #########################
    __onABTestingChanged = (key) => this.forceUpdate();
    __onSpotlightMode = () => {
        const currentMode = ModuleFE_Spotlight.getSpotlightData();
        if (!currentMode || currentMode.mode === 'support')
            this.forceUpdate();
    };
    __onPathwayEndUpdated = () => this.forceUpdate();
    __onReadOnlyChanged = () => this.forceUpdate();
    __onRuntimeProtocolsUpdated = (...params) => {
        //Trigger re-deriving to get new top protocols
        this.reDeriveState();
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve provider type & readonly mode into the state
        return state;
    }
    //######################### Logic #########################
    onPanelClick = () => ModuleFE_AdvisorMini.openPanel(this.props.panelKey);
    getPertinentDataEnabled = () => {
        const current = ModuleFE_AdvisorABTesting.getValue('pertinentData');
        return exists(current.abValue) && current.abValue !== ABTestValue.Disabled && current.actualValue;
    };
    //######################### Render #########################
    render() {
        const className = this.getPanelClass();
        const AB_PertinentData = this.getPertinentDataEnabled();
        return _jsx(TS_ErrorBoundary, { renderer: (e) => _jsx(Advisor_ErrorBoundary, { error: e, panelKey: this.props.panelKey, dir: this.state.focusedPanel ? 'vertical' : 'horizontal', onClick: () => {
                    this.reDeriveState({ error: undefined });
                } }), error: this.state.error, children: _jsxs(LL_V_L, { className: className, innerRef: this.panelRef, onClick: this._onPanelClick, "data-panel-key": this.props.panelKey, children: [_jsx(Component_HomeHeader, {}), _jsxs(FadeScrollWrapper, { children: [_jsx(Component_HomeHPIV2, {}), _jsx(Component_CatchUp_Vitals, {}), AB_PertinentData && _jsx(Component_PertinentData, {}), _jsx(Component_HomeScores, {}), !AB_PertinentData && _jsx(Component_HomeHistory, {}), _jsx(Component_HomeDDXV2, {})] }), _jsx(Component_MetapathwayOrderCart, {})] }) });
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => undefined;
    renderHeader_Tail = undefined;
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    renderContent = () => undefined;
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorMiniPanel_Home.js.map